import { toast } from "react-toastify";

import { CheckCircleIcon, CrossIcon } from "../../Icons";
import { Typo } from "../../Typo";

type Props = {
  title?: string;
  description?: string;
};

const SuccessToast = ({
  title,
  description,
  onClose,
}: Props & { onClose?: () => void }) => (
  <div
    className="relative flex w-full items-start gap-2 text-text-positive-bold"
    data-testid="success-toast"
  >
    <CheckCircleIcon className="h-5 w-5 shrink-0" />
    <div className="flex flex-1 flex-col gap-1">
      {title && (
        <Typo type="labelSM" textColor="inherit" className="font-semibold">
          {title}
        </Typo>
      )}
      {description && (
        <Typo type="bodySM" textColor="text-text-secondary">
          {description}
        </Typo>
      )}
    </div>
    <CrossIcon
      onClick={onClose}
      className="ml-2 h-4 w-4 cursor-pointer text-icon-secondary"
    />
  </div>
);

export function showSuccessToast({ title, description }: Props) {
  if (!title) return;
  return toast(
    ({ closeToast }) => (
      <SuccessToast
        title={title}
        description={description}
        onClose={closeToast}
      />
    ),
    {
      hideProgressBar: true,
      autoClose: 6000,
      closeButton: false,
      // react-toastify v11 replaces the container className when a per-toast className is provided.
      className:
        "!rounded-[var(--toastify-toast-bd-radius)] !bg-surface-accent-green-subtler",
    },
  );
}
